import { Outlet } from 'react-router-dom';
import { AppLogo, RazorLabsLogo } from '@/components/shared/display/Logo';
import { VideoBackground } from '@/layouts/components/VideoBackground';
import useScreenSize from '@/hooks/shared/useScreenSize';

const XL_BREAKPOINT = 1280;

export function AuthLayout() {
  const { width } = useScreenSize();
  const isDesktop = width >= XL_BREAKPOINT;

  return (
    <div className="flex items-center gap-0 w-full h-screen">
      <div className="w-full xl:w-1/2 h-full">
        <div className="absolute top-0 xl:top-[60px] left-10">
          {isDesktop ? <AppLogo size="184px" /> : <VideoBackground />}
        </div>

        <Outlet />
      </div>

      {isDesktop && (
        <div className="w-1/2 h-full">
          <VideoBackground />
          <div className="flex flex-col h-full justify-center items-center">
            <RazorLabsLogo />
          </div>
        </div>
      )}
    </div>
  );
}
